export default __webpack_public_path__ + "static/woodgrain-532af60b2f8aa0423eb7179722039af9.png";